module.exports = __webpack_public_path__ + "joy-static/media/TwoThumbsIcon.ef9c7ab4.svg";